import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/shipping-tradesy';

export default function Example() {
  return (
    <>
      <Head>
        <title>Tradesy Shipping 101: The Essentials to Get You Started</title>
        <meta
          name='description'
          content='Read and pick from the three shipping methods below if you haven’t tried selling on Tradesy yet. You might even want to try two or all of these methods to see which one works best for you!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/shipping-tradesy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/shipping-tradesy' />
        <meta property='og:title' content='Tradesy Shipping 101: The Essentials to Get You Started' />
        <meta
          property='og:description'
          content='Read and pick from the three shipping methods below if you haven’t tried selling on Tradesy yet. You might even want to try two or all of these methods to see which one works best for you!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Tradesy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
